// import { Provider } from 'react-redux'
import { useRoutes } from 'react-router'
import zhCN from 'antd/lib/locale/zh_CN'
import { ConfigProvider } from 'antd'

import routes from './config/routes'
import './App.css';

function App() {
  return <ConfigProvider locale={zhCN}>
    {/* <Provider store={store}> */}
    {useRoutes(routes)}
    {/* </Provider> */}
  </ConfigProvider>
}

export default App;
